import React from "react";
import { TextInput, Button, Container, Title, Paper, Alert, Select, Stack, Loader } from "@mantine/core";
import { MSIcon } from "components/MSIcon";
import { useTrans } from "core";
import api from "../services/ApiService";
import { useNavigate } from "react-router-dom";
import { Api_Region } from "../../../constants/SubApi.js";

export default function RegionScreen() {
	const { t, i18n } = useTrans();
	const navigate = useNavigate();

	const [nameAr, setNameAr] = React.useState("");
	const [nameEn, setNameEn] = React.useState("");
	const [selectedCountry, setSelectedCountry] = React.useState(null);
	const [countries, setCountries] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const [saving, setSaving] = React.useState(false);
	const [globalError, setGlobalError] = React.useState(null);
	const displayKey = i18n.language === "ar" ? "name_ar" : "name_en";

	React.useEffect(() => {
		loadRegions();
	}, []);

	const loadRegions = async () => {
		try {
			const res = await api.get(`/${Api_Region}/all`);
			setCountries(res);
		} catch (err) {
			setGlobalError(t("messages.faliedLoad"));
		} finally {
			setLoading(false);
		}
	};

	const saveRegion = async () => {
		setGlobalError(null);

		if (!nameAr || !nameEn) {
			setGlobalError(`${t("region.nameAr")} ${t("messages.required")}`);
			return;
		}

		setSaving(true);
		try {
			await api.post(`/${Api_Region}`, {
				name_ar: nameAr,
				name_en: nameEn,
				parentId: selectedCountry,
			});

			setNameAr("");
			setNameEn("");
			setSelectedCountry(null);

			await loadRegions();
		} catch (err) {
			const msg = err?.data?.message || "messages.error";
			setGlobalError(t(msg));
		} finally {
			setSaving(false);
		}
	};

	if (loading)
		return (
			<div>
				<Loader size="lg" style={{ display: "block", margin: "100px auto" }} />
			</div>
		);

	return (
		<Container size={500} my={20}>
			<Title order={2} mb={20}>
				{t("drawer.regionPage")}
			</Title>

			<Paper shadow="md" p={30} withBorder>
				{globalError && (
					<Alert icon={<MSIcon name="alert-circle" />} title={t("messages.error")} color="red" mb={15}>
						{globalError}
					</Alert>
				)}

				<Stack spacing={20}>
					<TextInput label={t("region.nameAr")} value={nameAr} onChange={(e) => setNameAr(e.target.value)} />

					<TextInput label={t("region.nameEn")} value={nameEn} onChange={(e) => setNameEn(e.target.value)} />

					<Select
						label={t("region.chooseCountry")}
						placeholder={t("region.chooseCountry")}
						value={selectedCountry}
						onChange={(val) => setSelectedCountry(val)}
						searchable
						clearable
						nothingFound={t("messages.noData")}
						data={countries.map((c) => ({
							value: c.id.toString(),
							label: c[displayKey],
						}))}
					/>

					<Button onClick={saveRegion} loading={saving} fullWidth>
						{t("region.save")}
					</Button>

					<Button variant="light" onClick={() => navigate(-1)} fullWidth>
						{t("region.cancel")}
					</Button>
				</Stack>
			</Paper>
		</Container>
	);
}
